import React, { useEffect, useState } from "react";
import columns from "../../../columns/restoreClient/restoreClient";
import {
  GetDeletedClientApi,
  RestoreClientApi,
} from "../../../api/request/restore/clients";
import SkeletonTable from "../../../components/table/SkeletonTable";
import moment from "moment";
import toast from "react-hot-toast";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import UserAvatar from "../../../components/common/UserAvatar";
import Search from "../../../components/common/Search";
import GlobalTooltip from "../../../components/common/GlobalTooltip";

const RestoreClients = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [filtered, setFiltered] = useState([]);

  const getDeletedClient = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetDeletedClientApi();
      if (data?.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              userDetails: (
                <UserAvatar
                  data={{
                    name: item?.name,
                    email: item?.email,
                    profile_image: item?.profile_image,
                  }}
                />
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              deleted_at: item?.deleted_at
                ? moment(item?.deleted_at).format("lll")
                : "",
              action: (
                <GlobalTooltip title={"Restore Client"}>
                  <button
                    onClick={() => {
                      setSelectedId(item?.id);
                      setIsOpen(true);
                    }}
                  >
                    <img src="/assets/icons/restore-file.svg" alt="Icon" />
                  </button>
                </GlobalTooltip>
              ),
            };
          })
        );
        setTotal(data?.total_record);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const restoreClient = async () => {
    try {
      setIsLoading(true);
      const params = { client_id: selectedId };
      const { data: response } = await RestoreClientApi(params);
      if (response?.status) {
        toast.success(response?.message);
        setIsOpen(false);
        setData(data?.filter((item) => item.id !== selectedId));
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDeletedClient();
  }, []);

  useEffect(() => {
    setFiltered(data);
  }, [data]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };

  return (
    <>
      <div className="border rounded-lg bg-White pb-5">
        <div className="sm:flex items-center justify-between p-5">
          <p className="title">Restore Clients {total ? `(${total})` : null}</p>
          <div className="md:w-auto w-40 ml-auto">
            <Search data={data} setFiltered={setFiltered} setTotal={setTotal} />
          </div>
        </div>

        <SkeletonTable
          columns={columns}
          data={filtered}
          isLoading={isLoading}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>

      {/* Confirmation modal for Restore Client */}
      <ConfirmationModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        message="Are you sure, you want to restore client?"
        onConfirm={restoreClient}
        isLoading={isLoading}
        loadingLabel="Restoring Client..."
      />
    </>
  );
};

export default RestoreClients;
